import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';
import DeleteAccount from './DeleteAccount';
import HomePage from './HomePage';
import './App.css';
import './i18n';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
    </Routes>
  );
};

export default App;
